import $axios from '../../api.js';

const state = () => ({
    businessData: {
        businessName: '',
        businessType: '',
        imageOutlet: '',
        mapsLocationData: {
            placeId: '',
            latitude: '',
            longitude: '',
            address: '',
            subAddress: '',
        },
        addressDetail: '',
        imageOutletBase64: false,
    },
});

const mutations = {
    SET_BUSINESS_DATA(state, payload) {
        state.businessData = {
            businessName: payload.name,
            businessType: payload.type,
            imageOutlet: payload.image,
            mapsLocationData: {
                placeId: payload.location.placeId,
                latitude: payload.location.latitude,
                longitude: payload.location.longitude,
                address: payload.location.address,
                subAddress: payload.location.subAddress,
            },
            addressDetail: payload.address_detail,
            imageOutletBase64: false,
        };
    },
    RESET_BUSINES_DATA(state) {
        state.businessData = {
            businessName: '',
            businessType: '',
            imageOutlet: '',
            mapsLocationData: {
                placeId: '',
                latitude: '',
                longitude: '',
                address: '',
                subAddress: '',
            },
            addressDetail: '',
            imageOutletBase64: false,
        };
    },
};

const actions = {
    getBusinessData({ commit }) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/customer/business')
                .then(response => {
                    commit('SET_BUSINESS_DATA', response.data.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    updateBusinessData({ state }) {
        return new Promise((resolve, reject) => {
            $axios
                .post('/customer/business', state.businessData)
                .then(response => {
                    // console.log(state.sender);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
